var cubeRequire = {};

module.exports = function(arrayRequire, cb) {

    var arrayToRequire = arrayRequire.filter(function(req) { return !cubeRequire[req]; });

    if (arrayToRequire.length === 0) return cb();

    var requireCount = 0;
    var requireFound = {};
    var requireLoaded = function(toRequire) {
        if (requireFound[toRequire]) return;
        requireFound[toRequire] = true;
        cubeRequire[toRequire] = true;
        requireCount++;
        if (requireCount == arrayToRequire.length) cb();
    }

    arrayToRequire.map(function(toRequire) {
        var script = document.createElement('script');
        script.type = 'text/javascript';
        // TODO : Rework (see 'external-js' gulp task)
        var name = toRequire.replace('cube:', '').replace('npm:', '');
        script.src = '/vassets/js/plugins/'+name+'.js';
        script.async = true;
        document.head.appendChild(script);
        script.onload = function() { requireLoaded(toRequire) }
    })

}


// WEBPACK FOOTER //
// ./src/modules-es5/commons/lib/lib-async-js.js